import type {
  Vignette,
  VignetteContent,
  VignetteVariantView,
} from '../types/Vignette';

export const getVignetteVariantView = (
  vignette: Vignette | null | undefined,
  viewedVariantId?: string | null
): VignetteVariantView | undefined => {
  if (!vignette?.variantViews?.length) {
    return undefined;
  }

  if (viewedVariantId) {
    const matchedVariantView = vignette.variantViews.find(
      (variantView) => variantView.variant.id === viewedVariantId
    );

    if (matchedVariantView) {
      return matchedVariantView;
    }
  }

  return (
    vignette.variantViews.find(
      (variantView) =>
        variantView.variant.id === vignette.presentedVariantId ||
        variantView.isAnswerable
    ) ?? vignette.variantViews[0]
  );
};

export const getDisplayedVignetteContent = (
  vignette?: Vignette | null,
  viewedVariantId?: string | null
): VignetteContent | undefined => {
  const variantView = getVignetteVariantView(vignette, viewedVariantId);
  if (variantView) {
    return variantView.variant;
  }

  return getPresentedVignetteContent(vignette);
};

export const getPresentedVignetteContent = (
  vignette?: Vignette | null
): VignetteContent | undefined => {
  if (!vignette) return undefined;

  if (vignette.schemaVersion === 'v2') {
    const fallbackContent = vignette.contents?.[0];

    if (!vignette.presentedVariant) {
      if (import.meta.env.DEV) {
        console.warn(
          '[vignetteVariants] Missing presentedVariant for V2 vignette; falling back to contents[0]',
          { vignetteId: vignette.id }
        );
      }
      return fallbackContent;
    }
    if (
      vignette.presentedVariantId &&
      vignette.presentedVariant.id !== vignette.presentedVariantId
    ) {
      if (import.meta.env.DEV) {
        console.warn(
          '[vignetteVariants] presentedVariantId mismatch for V2 vignette; falling back to contents[0]',
          {
            vignetteId: vignette.id,
            presentedVariantId: vignette.presentedVariantId,
            actualVariantId: vignette.presentedVariant.id,
          }
        );
      }
      return fallbackContent ?? vignette.presentedVariant;
    }
    return vignette.presentedVariant;
  }

  return vignette.contents?.[0];
};
